import * as S from "../Input.style";
import { UseFormRegisterReturn } from "react-hook-form";

interface InputDateProps {
  width?: string;
  size: string;
  themeType?: string;
  layout: string;
  label?: string;
  placeholder?: string;
  register?: UseFormRegisterReturn;
  disable?: any;
  error?: any;
  name?: any;
  defaultValue?: any;
  onChange?: any;
}

export const InputDate: React.FC<InputDateProps> = ({
  width,
  size,
  layout,
  themeType,
  label,
  placeholder,
  register,
  disable,
  error,
  name,
  onChange,
  defaultValue,
}) => {
  return (
    <S.InputCommon
      layout={layout}
      size={size}
      width={width}
      themeType={themeType}
    >
      <label>
        {label && label}
        <input
          type="date"
          defaultValue={defaultValue}
          placeholder={placeholder}
          disabled={disable}
          {...register}
          onChange={onChange}
        />
        {error ? <p className="message">{error[name]?.message}</p> : ""}
      </label>
    </S.InputCommon>
  );
};
